import axios from "axios";
import { BASE_URL } from "../utils/constants";

export interface ErrorLog {
    message: string;
    url?: string;
    stack?: string;
    status?: number;
    statusText?: string;
    timestamp: string;
    userAgent: string;
    networkStatus: string;
    metadata?: any;
}

/**
 * Logs an error to the server.
 * This is used to track frontend errors, especially network issues.
 */
export const logErrorToServer = async (error: any, metadata?: any) => {
    try {
        const logData: ErrorLog = {
            message: error.message || "Unknown error",
            url: error.config?.url || window.location.href,
            stack: error.stack,
            status: error.response?.status,
            statusText: error.response?.statusText,
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            networkStatus: navigator.onLine ? "online" : "offline",
            metadata: {
                ...metadata,
                requestData: error.config?.data,
                method: error.config?.method,
            },
        };

        // Use a separate axios instance or native fetch to avoid recursion if the logging itself fails
        await axios.post(`${BASE_URL}system/frontend-log`, logData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    } catch (loggingError) {
        // If logging fails, we just log to console to avoid infinite loops
        console.error("Failed to send log to server:", loggingError);
    }
};
